// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23TCa","toggle":"styles_toggle__bpMeD","preview":"styles_preview__2ozMC"};